import { mapFields } from '@/utils/maps'

/**
 * Tags mixin
 * @mixin
 */
export default {
	methods: {
		async loadWebsiteTags(websiteId) {
			return this.$ravello.graphql('tags')
				.parent(this.$ravello.graphql('website', websiteId))
				.datasource('name', 'slug')
				.query()
		},
		// Get collection tags
		getTags(collection, ids, { field = 'tags' } = {}) {
			const map = mapFields(collection, field)
			return ids.reduce((acc, id) => {
				const tags = map[id]
				if (!acc) {
					return [...tags]
				}
				return acc.filter(tag => tags.includes(tag))
			}, null)
		},

		// Get deleted tags from initial selection tags
		getDeletedTags(collection, ids, value, options) {
			return this.getTags(collection, ids, options)
				.filter(tag => !value.includes(tag))
		},

		// Get tags updates
		getTagsUpdates(collection, ids, value, options = {}) {
			const { field = 'tags' } = options
			const map = mapFields(collection, field)
			const deletedTags = this.getDeletedTags(collection, ids, value, options)

			return ids.map((id) => {
				const tags = [...map[id]]
				value.forEach((tag) => {
					if (!tags.includes(tag)) {
						tags.push(tag)
					}
				})
				deletedTags.forEach((tag) => {
					if (tags.includes(tag)) {
						tags.splice(tags.indexOf(tag), 1)
					}
				})

				return {
					_id: id,
					tags,
				}
			})
		},
	},
}
